(function () {
  'use strict';

  var main_nav_initialized = false;
  var $document = jQuery(document);
  var $window = jQuery(window);
  var $nav_menu_global = jQuery('.region-header-bottom nav.block-menu');
  var $nav_menu_global_top_level_lis = $nav_menu_global.children('ul').children('li');

  function is_desktop_mode() {
    return $window.innerWidth() >= ACG_CONSTANT.HEADER_DESKTOP_BREAKPOINT;
  }

  function add_section_overview_links() {
    $nav_menu_global_top_level_lis.each(function (event) {
      var $li = jQuery(this);
      var $submenu = $li.children('ul');
      var $a = $li.children('a');

      var $new_li = jQuery('<li class="menu-item menu-item--overview"></li>');
      var $new_a = jQuery('<a></a>')
        .attr('href', $a.attr('href'))
        .attr('data-drupal-link-system-path', $a.attr('data-drupal-link-system-path'))
        .text($a.text());

      $new_a.appendTo($new_li);
      $new_li.prependTo($submenu);
    });
  }

  Drupal.behaviors.main_nav = {
    attach: function (context, settings) {

      if (main_nav_initialized) {
        return;
      }

      add_section_overview_links();

      // Attach behavior to carets
      $nav_menu_global.find('ul ul').each(function () {
        var $submenu = jQuery(this);
        var $caret = $submenu.siblings('.menu-caret');
        var $parent_li = $submenu.parent();

        $caret.on('click', function (event) {
          if (!$parent_li.hasClass('open')) {
            openThisMenu();
          }
          else {
            closeThisMenu();
          }
        });

        function openThisMenu() {
          $parent_li.addClass('open');
          registerClickElsewhereHandler();
          closeAllOtherMenus();
        }

        function closeThisMenu() {
          $parent_li.removeClass('open');
          deregisterClickElsewhereHandler();
        }

        function closeAllOtherMenus() {
          // console.log('unimplemented');
        }

        function clickElsewhereHandler(event) {
          var $clickTarget = jQuery(event.target);

          // If clicktarget is not a descendant of the parent LI...
          if ($clickTarget.closest($parent_li).length === 0) {
            // Close the menu
            closeThisMenu();
          }
        }

        function registerClickElsewhereHandler() {
          $document.on('click', clickElsewhereHandler);
        }

        function deregisterClickElsewhereHandler() {
          $document.off('click', clickElsewhereHandler);
        }

      });

      // Attach hover behaviors to LI items
      jQuery('a', $nav_menu_global).each(function () {
        var $a = jQuery(this);
        var $li = $a.parent();
        var $caret = $a.siblings('.menu-caret');
        var $submenu = $a.siblings('ul');

        var is_top_level = ($li.parent().parent().prop('nodeName') === 'NAV');

        $li.on('click', function (event) {

          // don't intercept if click is not on top level
          if (!is_top_level) {
            return;
          }

          var $target = jQuery(event.target);

          // don't intercept if click was actually inside the submenu
          if ($target.closest($submenu).length > 0) {
            return;
          }

          // don't intercept in mobile mode
          if (!is_desktop_mode()) {
            return;
          }

          // don't intercept if click was on caret
          if ($target.is($caret)) {
            return;
          }

          if ($caret.length > 0) {

            if ($target.prop('nodeName') === 'A') {
              // If click was on A, prevent link from firing
              event.preventDefault();
            }

            // Whether click was on A or LI, translate it into a click on caret
            $caret.click();
          }
        });
      });

      main_nav_initialized = true;
    }
  };
})(jQuery);
